import store from "../redux/store";
import {signInPath} from "../routes/paths";
import {setSignedOut} from "../redux/actions/authActions";
import {login_url} from "./apiAuthUrls";

export const isSignInRequest = (config) =>
  Boolean(config?.url?.includes(login_url));

export const handle401 = (error) => {
  if (!isSignInRequest(error.config)) {
    store.dispatch(setSignedOut());
    window.location = signInPath;
  }
};